import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { EnvironmentService } from '@services/environment/environment.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { FileAssetsService } from '@services/assets/file-assets.service';
import { VideoAssetsService } from '@services/assets/video-assets.service';

@Component({
    selector: 'edit-asset-modal',
    templateUrl: './edit-asset.component.html',
    styleUrls: ['./edit-asset.component.scss'],
    providers: [VideoAssetsService, FileAssetsService],
    standalone: false
})

export class EditAssetComponent implements OnInit {
  asset;
  isInContent;
  public resourceTranslations: any;
  public generalTranslations: any;
  titleUpdated = false;

  constructor(
    public dialogRef: MatDialogRef<EditAssetComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private ts: TranslateService, private environmentService: EnvironmentService,
    private snackbar: SnackbarService, private videoAssetService: VideoAssetsService, private fileAssetService: FileAssetsService
  ) {
  }

  async ngOnInit() {
    this.resourceTranslations = this.ts.get('resources');
    this.generalTranslations = this.ts.get('system');
  }

  cancelChanges() {
    this.dialogRef.close();
  }

  titleUpdate() {
    this.titleUpdated = true;
  }

  async onSave() {
    if (this.data.type === 'file') {
      await this.fileAssetService.update(this.data.asset._id, this.data.asset);
    } else if (this.data.type === 'video' || this.data?.asset?.mimeType?.includes('video')) {
      await this.videoAssetService.update(this.data.asset._id, this.data.asset);
    }
    this.titleUpdated = false;
    this.snackbar.success(this.generalTranslations.dynamicContent.saved, 5000);
  }
}
